import React, { useRef, useEffect, useState } from "react";
import DependentChildCard from "./DependentChildCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { isArabic } from "../../../utils/util";

const DependentList = ({
  dependents,
  onChildSelect,
  isApiLoading,
  translationMap,
  selectedChildId
}) => {
  const [isArabicLang, setIsArabicLang] = useState(false);
  const [key, setKey] = useState(0);
  const [sliderSettings, setSliderSettings] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  useEffect(() => {
    const lang = isArabic();

    setIsArabicLang(lang);
    setKey((prevKey) => prevKey + 1);
  }, []);

  useEffect(() => {
    const slidesToShow = dependents.length < 4 ? dependents.length : 4;
    const lastSlideIndex = Math.max(dependents.length - slidesToShow, 0);

    setSliderSettings({
      infinite: false,
      speed: 1200,
      slidesToShow,
      slidesToScroll: slidesToShow,
      arrows: false,
      variableWidth: true,
      rtl: isArabicLang,
      initialSlide: isArabicLang ? lastSlideIndex : 0,
      afterChange: (current) => setCurrentSlide(current),
      responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: Math.min(dependents.length, 4),
          slidesToScroll: Math.min(dependents.length, 4)
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(dependents.length, 2),
          slidesToScroll: Math.min(dependents.length, 2)
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(dependents.length, 2),
          slidesToScroll: Math.min(dependents.length, 2)
        }
      }]

    });
  }, [isArabicLang, dependents.length]);


  const hasMovedSlider = useRef(false);

  useEffect(() => {
    if (!sliderRef.current || !isArabicLang) return;

    const slidesToShow = dependents.length < 4 ? dependents.length : 4;
    const lastSlideIndex = Math.max(dependents.length - slidesToShow, 0);

    if (!hasMovedSlider.current && isArabicLang) {
      setTimeout(() => {
        if (sliderRef.current) {



          sliderRef.current.slickGoTo(lastSlideIndex);
          hasMovedSlider.current = true;
        }
      }, 300);
    } else {
      setTimeout(() => {
        if (sliderRef.current) {



          sliderRef.current.slickGoTo(0);
          hasMovedSlider.current = true;
        }
      }, 300);

    }
    return () => {
      hasMovedSlider.current = false;
    };
  }, [isArabicLang, dependents.length]);

  const next = () => {
    if (sliderRef.current) {
      isArabicLang ? sliderRef.current.slickNext() : sliderRef.current.slickNext();
    }
  };

  const previous = () => {
    if (sliderRef.current) {
      isArabicLang ? sliderRef.current.slickPrev() : sliderRef.current.slickPrev();
    }
  };

  const slidesToShow = sliderSettings?.slidesToShow || 4;
  const lastSlide = Math.max(dependents.length - slidesToShow, 0);

  const isPrevDisabled = isArabicLang ? currentSlide === 0 : currentSlide === 0;
  const isNextDisabled = isArabicLang ? currentSlide >= lastSlide : currentSlide >= lastSlide;

  return (
    <>
      {dependents.length > 0 ?
      <div>
          <div className="title_box">
            <h6 className="MainTitleOne">{translationMap?.myDependentsList}</h6>
            <div className="slideNxtPrev">
              <div className="owlNavBtn">
                {dependents.length > 4 &&
              <div className="btn-wrap">
                    <button
                  className="prev-btn"
                  onClick={previous}
                  disabled={isPrevDisabled}>
                  
                      <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    
                        <path
                      d="M12.5 15L7.5 10L12.5 5"
                      stroke={currentSlide === 0 ? "#ccc" : "#002F70"}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round" />
                    
                      </svg>
                    </button>
                    <button
                  className="next-btn"
                  onClick={next}
                  disabled={isNextDisabled}>
                  
                      <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    
                        <path
                      d="M7.5 15L12.5 10L7.5 5"
                      stroke={currentSlide >= lastSlide ? "#ccc" : "#002F70"}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round" />
                    
                      </svg>
                    </button>
                  </div>
              }
              </div>
            </div>
          </div>

          <div className="baraem_dependent_list_slider_box">
            <Slider key={key} ref={sliderRef} {...sliderSettings}>
              {dependents.map((dependent, index) =>
            <div key={index} onClick={() => onChildSelect(dependent)}>
                  <DependentChildCard
                dependent={dependent}
                translationMap={translationMap}
                selectedChildId={selectedChildId} />
              
                </div>
            )}
            </Slider>
          </div>
        </div> :
      isApiLoading ?
      <div></div> :

      <div className="baraem_main_inner_wrapper baraem_main_inner_wrapper2">
          <div className="AlertInnerBox YellowAlertInnerBox">
            <div className="Icon_box">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
              <a href="javascript:void(0);">
                <span className="material-symbols-outlined">info</span>
              </a>
            </div>
            <div className="alert_text">
              <h6>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                <a href="javascript:void(0);">
                  {translationMap?.noChildrenAddedText ??
                "No children have been added yet. Please add a child."}
                </a>
              </h6>
            </div>
          </div>
        </div>
      }
    </>);

};

export default DependentList;